import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppFooterPublic } from './_Footers/AppFooterPublic';
import { AppHeaderPublic } from './_Headers/AppHeaderPublic';
import { onApplyLayoutTemplate } from '../_Templates/AppTemplateResolved';
import { useSectionTitle } from '../../../_CORE/Hooks/useSectionMetaTitle';
import { AppHeaderUtilities } from './_Headers/_Utilities/AppHeaderUtilities';
import { useLanguage } from '../../../_CORE/Contexts/Translate/useLanguageContext';
import { APP_LAYOUT_STRUCTURE, onResolveLayoutNavigation } from './AppLayoutStructure';
import { useUserAuthenticated } from '../../../_CORE/Contexts/_Auth/userAuthenticatedContext';
import { APP_ENVIRONMENT } from '../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppEnvironment.js';
import { BannerModeDevelopment } from '../../../_CORE/_RuntimeConfig/_Config/Acomodar/BannerModeDevelopment.js';

export const AppLayoutPublic = ({ outletContext = {} }) => {

    const LOCATION = useLocation();
    const IS_LOOPY_LANDING = LOCATION.pathname === '/';

    const { useDataLanguage } = useLanguage();
    const { useDataUserAuth: USER_AUTH, onCallbackCloseSessionUserAuth: ON_LOGOUT } = useUserAuthenticated();

    const LAYOUT_NAV = onResolveLayoutNavigation(USER_AUTH?.data ?? null, useDataLanguage.currentLang);
    const BRAND = { ...APP_LAYOUT_STRUCTURE.brand, claim: LAYOUT_NAV.claim };

    useSectionTitle(LAYOUT_NAV.publicRoutes, APP_LAYOUT_STRUCTURE.brand.name);

    useEffect(() => {
        onApplyLayoutTemplate(APP_ENVIRONMENT.TEMPLATES.LAYOUT_STRUCTURE_PUBLIC);
    }, []);

    return (
        <div className="LStudio__app_layout LStudio__app_layout--public">
            {

                APP_LAYOUT_STRUCTURE.ui.headerPublic && !IS_LOOPY_LANDING && (
                    <AppHeaderPublic brand={BRAND} navItems={LAYOUT_NAV.publicNav} utilities={(
                        <AppHeaderUtilities
                            isAuth={USER_AUTH?.isAuthenticated === true}
                            user={USER_AUTH} onClickLogout={ON_LOGOUT}
                            profileLinks={LAYOUT_NAV.profileLinks}
                            languages={APP_LAYOUT_STRUCTURE.languages} data={{}} />
                    )}
                    />
                )
            }

            <BannerModeDevelopment />

            <main className="LStudio__app_layout__main" style={{ minHeight: "100vh" }}>
                <Outlet context={outletContext} />
            </main>

            {
                APP_LAYOUT_STRUCTURE.ui.footerPublic && !IS_LOOPY_LANDING && (
                    <AppFooterPublic  brand={BRAND}   columns={LAYOUT_NAV.footerColumns}
                        legal={LAYOUT_NAV.legal}  showBrandLS={APP_LAYOUT_STRUCTURE.showBrandLS}
                    />
                )
            }
        </div>
    );
};
